import React from 'react';
import SvgIcon from '../SvgIconWrapper';

interface TimesIconProps {
  size?: number;
  color?: string;
  strokeWidth?: number | string;
}

const TimesIcon: React.FC<TimesIconProps> = ({ strokeWidth = 4, ...props }) => (
  <SvgIcon {...props} viewBox="0 0 50 50" className="sx-icon-times">
    <path
      d="M10 10 L40 40 M40 10 L10 40"
      fill="none"
      stroke={props.color || 'currentColor'}
      strokeWidth={strokeWidth}
      strokeLinecap="butt"
    />
  </SvgIcon>
);

export default TimesIcon;
